import { Action } from '@ngrx/store';

export enum AlphabetSelectionActionTypes {
    SelectedAlphabar = '[Letter] Selected Alphabar'
}

export class SelectedAlphabar implements Action {
  readonly type = AlphabetSelectionActionTypes.SelectedAlphabar; 

  constructor(public identifier: string, public selectedAlpha: string) {}
}

export type AlphabetSelectionActions = SelectedAlphabar; 